/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-google': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.119 8.637H10.13v2.894h4.025c-.375 1.844-1.944 2.9-4.025 2.9a4.431 4.431 0 110-8.862 4.375 4.375 0 012.763.987l2.181-2.181A7.5 7.5 0 1010.131 17.5c3.75 0 7.157-2.725 7.157-7.5a5.975 5.975 0 00-.17-1.363z"/>'
  }
})
